import React from "react";
import { Route,Routes } from "react-router-dom";
import Home from "./components/Home";
import ChatPage from "./components/ChatPage";
// import ContentLoading from "./components/co-components/ContentLoading"
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'

function App() {
  
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/chats" element={<ChatPage/>} />
        {/* <Route path="/contentLoading" element={<ContentLoading/>} /> */}
      </Routes>
    </div>
  );
}

export default App;
